import AttributesProgressiveField from './AttributesProgressiveField'

export default AttributesProgressiveField
